<template>
	<Full168 v-if="isFull168" />
	<Full v-else />
</template>


<script setup>
import { computed } from 'vue';
import { isBuild } from '@/utils/const';
import Full168 from './full_168.vue';
import Full from '@rebuild/materials/shared/custom/Full.vue';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';

const { getRealModuleId } = useCustomCore();

const getModuleId = computed(() => {
	return getRealModuleId();
});

//168为康耐特已经订阅的财务报告自定义模块id, 347为测试环境随便新建的一个自定义模块id
const isFull168 = computed(() => {
	return isBuild ? getModuleId.value == 168 : getModuleId.value == 347;
});
</script>



<style lang="less" scoped>
</style>